import { WalletImportMethod } from "@syla/shared/types/models/WalletBase";
import { Wallet } from "../../../types/wallet/wallet";

export const getEditDataSourceText = ({
  authorised,
  importMethod,
}: Pick<Wallet, "authorised" | "importMethod">) =>
  importMethod == WalletImportMethod.API && !authorised ? "Fix Access" : "Edit";
